import { defineAsyncComponent } from 'vue';
import HawkLoader from '~/common/components/atoms/hawk-loader.vue';
import Files from '~/dms/pages/files.vue';

const DMSCustomFields = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/dms-custom-fields.vue'),
  loadingComponent: HawkLoader,
});
const DMSStampSettings = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/dms-stamp-settings.vue'),
  loadingComponent: HawkLoader,
});
const CreateTransmittals = defineAsyncComponent({
  loader: () => import('~/dms/pages/transmittals/create-transmittals.vue'),
  loadingComponent: HawkLoader,
});

// ------------- Transmittals -------------------------------

const DmsTransmittals = defineAsyncComponent({
  loader: () => import('~/dms/pages/transmittals/dms-transmittals.vue'),
  loadingComponent: HawkLoader,
});
const TransmittalDetailPage = defineAsyncComponent({
  loader: () => import('~/dms/pages/transmittals/transmittal-detail-page.vue'),
  loadingComponent: HawkLoader,
});

const TransmittalDetailSettings = defineAsyncComponent({
  loader: () => import('~/dms/pages/transmittals/transmittal-detail-settings.vue'),
  loadingComponent: HawkLoader,
});
const TransmittalPublicPage = defineAsyncComponent({
  loader: () => import('~/dms/pages/transmittals/transmittal-public-page.vue'),
  loadingComponent: HawkLoader,
});

// ------------- Settings ---------------------------------

const Settings = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/settings.vue'),
  loadingComponent: HawkLoader,
});
const TransmittalSettings = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/transmittal-settings.vue'),
  loadingComponent: HawkLoader,
});
const WorkflowTemplates = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/workflow-templates.vue'),
  loadingComponent: HawkLoader,
});

const Documents = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/documents.vue'),
  loadingComponent: HawkLoader,
});
const CustomStatus = defineAsyncComponent({
  loader: () => import('~/dms/pages/settings/custom-status.vue'),
  loadingComponent: HawkLoader,
});
const DocumentAllFiles = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/document-all-files.vue'),
  loadingComponent: HawkLoader,
});
const DocumentShared = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/document-shared.vue'),
  loadingComponent: HawkLoader,
});
const DocumentArchived = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/document-archived.vue'),
  loadingComponent: HawkLoader,
});
const DocumentTrash = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/document-trash.vue'),
  loadingComponent: HawkLoader,
});
const DocumentAddMarkups = defineAsyncComponent({
  loader: () => import('~/dms/pages/documents/document-add-markups.vue'),
  loadingComponent: HawkLoader,
});

const routes = [
  {
    path: '/:asset_id?/dms',
    name: 'dms',
    component: Files,
    meta: {
      title: 'Files',
      requireModuleAccess: 'files',
    },
    redirect: { name: 'files-documents' },
    children: [
      {
        path: 'documents',
        component: Documents,
        name: 'files-documents',
        redirect: { name: 'files-documents-all-files' },
        meta: {
          module: 'dms',

        },
        children: [{
          path: 'all',
          component: DocumentAllFiles,
          name: 'files-documents-all-files',
          meta: {
            page: 'files',
          },
          props: route => ({ asset_id: route.params.asset_id }),
        }, {
          path: 'shared',
          component: DocumentShared,
          name: 'files-documents-shared',
          meta: {
            page: 'shared',
          },
          props: route => ({ asset_id: route.params.asset_id }),
        }, {
          path: 'archived',
          component: DocumentArchived,
          name: 'files-documents-archived',
          meta: {
            page: 'archive',
          },
          props: route => ({ asset_id: route.params.asset_id }),
        }, {
          path: 'trash',
          component: DocumentTrash,
          name: 'files-documents-trash',
          meta: {
            page: 'trash',
          },
          props: route => ({ asset_id: route.params.asset_id }),
        }],
      },
      {
        path: 'transmittals',
        component: DmsTransmittals,
        name: 'files-transmittals',
        meta: {
          module: 'dms',

        },
      },
      {
        path: 'settings',
        component: Settings,
        name: 'dms-settings',
        redirect: { name: 'dms-custom-status' },
        meta: {
          module: 'dms',

        },
        children: [
          {
            path: 'custom-status',
            component: CustomStatus,
            name: 'dms-custom-status',
            meta: {
              module: 'dms',

            },
          },
          {
            path: 'custom-fields',
            component: DMSCustomFields,
            name: 'dms-custom-fields',
            meta: {
              module: 'dms',

            },
          },
          {
            path: 'dms-stamp-settings',
            component: DMSStampSettings,
            name: 'dms-stamp-settings',
            meta: {
              module: 'dms',
            },
          },
          {
            path: 'transmittal-settings',
            component: TransmittalSettings,
            name: 'dms-transmittal-settings',
            meta: {
              module: 'dms',

            },
          },
          {
            path: 'workflow-templates',
            component: WorkflowTemplates,
            name: 'dms-workflow-templates',
            meta: {
              module: 'dms',

            },
          },
        ],
      },
    ],
  },
  {
    path: '/:asset_id?/transmittals/:transmittal_uid',
    component: TransmittalDetailPage,
    name: 'files-transmittals-detail',
    meta: {
      module: 'dms',
      requireModuleAccess: 'transmittals',
    },
    children: [
      {
        path: 'settings',
        name: 'transmittal-detail-settings',
        component: TransmittalDetailSettings,
        meta: {
          module: 'dms',

        },
      },
      {
        path: 'document-markup/:document_uid',
        name: 'document-markup',
        component: DocumentAddMarkups,
        meta: {
          module: 'dms',

        },
      },
    ],
  },
  {
    path: '/:asset_id?/transmittals-create',
    component: CreateTransmittals,
    name: 'files-create-transmittals',
    meta: {
      module: 'dms',
      requireModuleAccess: 'transmittals',
    },
  },
  {
    path: '/transmittals/:transmittal_uid/public',
    component: TransmittalPublicPage,
    name: 'public-transmittals',
    meta: {
      module: 'dms',
      layout: 'public',
      noAuthRequires: true,
    },
  },
];
export default routes;
